import { Button, Col, Form, Row } from 'react-bootstrap';
import submitApplicationSignal, { } from 'signals/SubmitApplication.signal';
import {
  handleSelectionChange,
  nextStepUnlessApplicationAlreadyExists,
} from '../SubmitApplications.helpers';
import userAccountSignal from '../../../../signals/UserAccount.signal';
import $appSettings from 'signals/AppSettings.signal';

const SubmitApplicationsChooseProgram = () => {
  const {
    fundingProgramId,
    initialStatus,
  } = submitApplicationSignal.value;
  const { APPLICATION_STATUS, PORTAL_TYPES } = $appSettings.value.constants;


  return (
    <>
      <Row>
        <Col>
          <h4>Application Program</h4>
        </Col>
      </Row>
      <h5 className="mt-32">Program Information</h5>
      <Row>
        <Col>
          <Form.Group className="form-group">
            <Form.Label className="font-weight-bold text-secondary">
              Select a Funding Program
            </Form.Label>
            <Form.Select
              className="form-control"
              name="fundingProgram"
              value={fundingProgramId}
              onChange={(e) => handleSelectionChange(e)}
            >
              <option value="-1" key="-1">
                Select a Specific Program
              </option>
              {submitApplicationSignal.value.fundingPrograms?.map((mp) => (
                <option value={mp.id} key={mp.id}>
                  {`${mp.name}${
                    mp.ocrModelKey
                      ? ''
                      : ' (manual digital form - OCR not configured)'
                  }`}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      {userAccountSignal.value.userData.account.portalType ===
        PORTAL_TYPES.edo && (
        <>
          <h5 className="mt-32">Initial Status</h5>
          <Row>
            <Col>
              <Form.Group className="form-group">
                <Form.Label className="font-weight-bold text-secondary">
                  Initial Status
                </Form.Label>
                <Form.Select
                  className="form-control"
                  name="initialStatus"
                  value={initialStatus}
                  onChange={(e) => handleSelectionChange(e)}
                >
                  <option
                    value={APPLICATION_STATUS.pending}
                    key={APPLICATION_STATUS.pending}
                  >
                    Pending
                  </option>
                  <option
                    value={APPLICATION_STATUS.approved}
                    key={APPLICATION_STATUS.approved}
                  >
                    Approved
                  </option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </>
      )}
      <Row className="justify-content-center p-16">
        <Button
          className="rounded"
          onClick={nextStepUnlessApplicationAlreadyExists}
          disabled={!initialStatus || !fundingProgramId || Number(fundingProgramId) <= 0}
        >
          Next
        </Button>
      </Row>
    </>
  );
};

export default SubmitApplicationsChooseProgram;
